<template>
    <div>
        <div class="single-option">
            <el-radio-group v-model="data.value">
                <el-radio :label="index" v-for="(item, index) in data.option" class="single-option">
                    <el-input v-model="item.name" placeholder="请输入内容" class="single-input"></el-input>
                    <i class="el-icon-close" @click.stop="del(index)"></i>
                </el-radio>
            </el-radio-group>
        </div>
        <el-button type="primary" plain @click="addOption">+ 添加选项</el-button>
    </div>
</template>

<script>
    export default {
        name: "SingleChoice",
        props: ['data'],
        data() {
            return {

            }
        },
        methods: {
            //添加选项
            addOption() {
                let option = {
                    name: ''
                }
                if (this.data.option.length < 4) {
                    this.data.option.push(option);
                } else {
                    this.$message({
                        message: '最多只能添加四个选项！',
                        type: 'warning'
                    });
                }
            },
            del(index) {
                this.data.option.splice(index, 1);
            }
        }
    }
</script>

<style scoped lang="scss">
    .single-option {
        margin-bottom: 10px;
        .single-input {
            width: 90%;
        }
    }
</style>